import React, { useState } from "react";
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogFooter,
    AlertDialogCancel,
    AlertDialogAction,
} from "../../components/ui/alert-dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useTranslation } from "react-i18next";

const OrgRegNoModal = ({ open, onOpenChange, onConfirm, loading }) => {
    const { t } = useTranslation();
    const [regNo, setRegNo] = useState("");
    const [error, setError] = useState("");

    const handleConfirm = (e) => {
        e.preventDefault();
        if (regNo.length !== 7 || !/^\d+$/.test(regNo)) {
            setError(t("orgRegNoLengthError") || "Байгууллагын регистр 7 оронтой тоо байх ёстой");
            return;
        }
        setError("");
        onConfirm(regNo);
    };

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent className="max-w-md">
                <AlertDialogHeader>
                    <AlertDialogTitle>{t("enterOrgRegNo") || "Байгууллагын регистрийн дугаар оруулна уу"}</AlertDialogTitle>
                </AlertDialogHeader>

                <div className="space-y-4 py-4">
                    <div className="space-y-2">
                        <Label htmlFor="orgRegNo">
                            {t("orgRegNo") || "Байгууллагын регистр (7 орон)"}
                        </Label>
                        <Input
                            id="orgRegNo"
                            placeholder="1234567"
                            value={regNo}
                            onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "").slice(0, 7);
                                setRegNo(val);
                                if (val.length === 7) setError("");
                            }}
                            className={error ? "border-destructive" : ""}
                            autoFocus
                        />
                        {error && (
                            <p className="text-sm text-destructive font-medium">
                                {error}
                            </p>
                        )}
                    </div>
                </div>

                <AlertDialogFooter>
                    <AlertDialogCancel disabled={loading}>
                        {t("cancel") || "Болих"}
                    </AlertDialogCancel>
                    <AlertDialogAction 
                        onClick={handleConfirm}
                        disabled={loading || regNo.length !== 7}
                    >
                        {loading ? (t("processing") || "Боловсруулж байна...") : (t("continue") || "Үргэлжлүүлэх")}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default OrgRegNoModal;
